import { DiscoPublisherStatus } from "@redotech/congo-enums/disco-publisher-status";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Asks Disco to onboard the store as a publisher. Disco reviews the request, so
 * the returned status is usually pending rather than approved.
 */
export const connectDiscoOfferNetwork = {
  name: "connectDiscoOfferNetwork" as const,
  input: z.object({
    primaryCategoryId: z.string().min(1),
    subcategoryIds: z.array(z.string().min(1)),
  }),
  output: z.object({
    success: z.boolean(),
    status: createEnum(Object.values(DiscoPublisherStatus)),
  }),
};
